import React, { useState } from "react";
import StudentPausePopup from "../StudentPausePopup";
import green_tick_epicenter from "../../../assets/images/green_tick_epicenter.svg";
import ActionButtons from "../ActionButtons";
import { useStyles } from "./style";

const ClassesResumedSuccessModal = ({
  isSuccessModalOpen,
  setIsSuccessModalOpen,
}) => {
  const classes = useStyles();
  const handleClosePopup = () => {
    setIsSuccessModalOpen(false);
  };
  return (
    <>
      <StudentPausePopup open={isSuccessModalOpen}>
        <div className={classes.successModal}>
          <img
            src={green_tick_epicenter}
            alt="Classes Resumed"
            className={classes.tickIcon}
          />
          <p className={classes.successMsg}>
            Classes have been resumed successfully
          </p>
          <ActionButtons
            cancelBtnText={"Close"}
            handleCancel={handleClosePopup}
            showProceedBtn={false}
          />
        </div>
      </StudentPausePopup>
    </>
  );
};

export default ClassesResumedSuccessModal;
